import React from "react";

const getViewBox = name => {
  switch (name) {
    case "Search":
      return "0 0 18 18";
    case "Instagram":
      return "0 0 18 18";
    case "arrow-right":
      return "0 0 20 20";
    case "external":
        return "0 0 20 20";
    case "download":
          return "0 0 20 20";
    default:
      return "0 0 18 18";
  }
};

const getPath = (name, props) => {
  switch (name) {
    case "Search":
      return (
        <path
          {...props}
          clipRule="evenodd"
          fillRule="evenodd"
          d="M8.33329 15C4.65139 15 1.66663 12.0152 1.66663 8.33332C1.66663 4.65142 4.65139 1.66666 8.33329 1.66666C12.0152 1.66666 15 4.65142 15 8.33332C15 9.87392 14.4774 11.2925 13.5998 12.4214L18.0892 16.9107L16.9107 18.0892L12.4213 13.5999C11.2924 14.4774 9.87389 15 8.33329 15ZM13.3333 8.33332C13.3333 11.0947 11.0947 13.3333 8.33329 13.3333C5.57187 13.3333 3.33329 11.0947 3.33329 8.33332C3.33329 5.5719 5.57187 3.33332 8.33329 3.33332C11.0947 3.33332 13.3333 5.5719 13.3333 8.33332Z"
        />
      );
    case "Telephone":
      return (
        <path
          {...props}
          clipRule="evenodd"
          fillRule="evenodd"
          d="M8.04709 5.94832C8.47885 5.36648 8.63367 4.75327 8.14537 4.212C7.04957 2.67868 6.31262 1.73048 5.85037 1.27385C4.97157 0.405741 3.52593 0.523167 2.76483 1.27311C2.35603 1.67591 2.21763 1.81424 1.79789 2.24058C-0.540154 4.57988 0.885705 9.52507 4.67616 13.3193C8.46575 17.1126 13.4105 18.5392 15.7534 16.1949C16.1408 15.8215 16.4687 15.4934 16.7273 15.2201C17.4732 14.4317 17.5864 13.0498 16.7224 12.1521C16.2795 11.6918 15.3753 10.9905 13.7774 9.84752C13.2881 9.40993 12.7078 9.50477 12.1759 9.85377C11.92 10.0217 11.7338 10.1915 11.3821 10.5435L10.7436 11.1823C10.6595 11.2665 9.51749 10.6946 8.40893 9.58493C7.29977 8.47468 6.72825 7.33262 6.81196 7.24892L7.45093 6.60959C7.5625 6.49792 7.61583 6.44385 7.68423 6.37196C7.82674 6.22219 7.94473 6.08627 8.04709 5.94832ZM11.9214 12.3609L12.5601 11.7218C12.7536 11.5281 12.8791 11.409 12.9811 11.3269C14.3808 12.3321 15.1914 12.9641 15.5226 13.3082C15.7213 13.5147 15.6905 13.8916 15.5176 14.0743C15.2785 14.3271 14.9678 14.638 14.5865 15.0057C13.0714 16.5214 9.07992 15.3698 5.85427 12.141C2.62762 8.91117 1.47657 4.91906 2.98016 3.41464C3.39822 2.99005 3.53067 2.85767 3.93363 2.46062C4.08472 2.31174 4.49627 2.27831 4.68006 2.45987C5.03595 2.81144 5.69612 3.65673 6.66726 5.00951C6.61698 5.07193 6.55419 5.14246 6.47778 5.22277C6.42169 5.28172 6.37497 5.32908 6.27282 5.43133L5.63447 6.07003C4.54851 7.1559 5.47335 9.004 7.23081 10.7632C8.98707 12.5212 10.8359 13.447 11.9214 12.3609Z"
        />
      );
    case "arrow-right":
      return (
        <path
          {...props}
          style={{paddingTop: '4px'}}
          clipRule="evenodd"
          fillRule="evenodd"
          d="M15.5858 11.0001H1V9.00008H15.5858L9.29289 2.70718L10.7071 1.29297L19.4142 10.0001L10.7071 18.7072L9.29289 17.293L15.5858 11.0001Z"
          stroke="#52288E"
        />
      );
      case "external":
        return (
          <path
            {...props}
            clipRule="evenodd"
            fillRule="evenodd"
            d="M9.20421 11.7071L16.4971 4.41421V9H18.4971V1H10.4971V3H15.0829L7.78999 10.2929L9.20421 11.7071ZM16.5 17V12H14.5V17H2.5V5H7.5V3H2.5C1.39543 3 0.5 3.89543 0.5 5V17C0.5 18.1046 1.39543 19 2.5 19H14.5C15.6046 19 16.5 18.1046 16.5 17Z"
          />
      
        );
        case "download":
        return (
          <path
            {...props}
            clipRule="evenodd"
            fillRule="evenodd"
            d="M14.2929 7.29289L11 10.5858V0H9V10.5858L5.70711 7.29289L4.29289 8.70711L10 14.4142L15.7071 8.70711L14.2929 7.29289ZM20 18V14H18V18H2V14H0V18C0 19.1046 0.89543 20 2 20H18C19.1046 20 20 19.1046 20 18Z"
          />
        );
    default:
      return <path />;
  }
};


const TopBarIcons = ({
  name = "",
  style = {},
  fill = "#52288E",
  viewBox = "",
  width = "18",
  className = "",
  height = "18"
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox || getViewBox(name)}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    {getPath(name, { fill })}
  </svg>
);


export default TopBarIcons;